import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import NumberFormat from 'react-number-format';

import { Select, message } from 'antd';

import { combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { downloadTechSummary, userAssociatedFacilities } from '../../../common/services/ApiService';

import { toast } from '@rickylandino/react-messages';

import Axios from '../../../config/axios';
import Moment from 'moment';

class TechDetailsReportModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: props.showModal,
            allFacilities: [],
            selectedFacility: '',
            availableTechs: [],
            selectedTech: '',
            availableExamTypes: [],
            selectedExamTypes: [],
            selectedDates: {
                startDate: null,
                endDate: null
            },
            showDetails: false
        }

        this.alive = false;
    }

    componentDidMount() {
        this.alive = true;

        combineLatest(
            userAssociatedFacilities
        ).pipe(takeWhile(() => this.alive)).subscribe(([f]) => {
            if (f?.length > 0) {

                let selectedFacility = '';

                if (f.length === 1) {
                    selectedFacility = f[0].facilityModel.facilityID;
                }

                this.setState({
                    allFacilities: f,
                    selectedFacility,
                    loaded: true
                }, () => {
                    if (f.length === 1) {
                        this.handleFacilityChange(selectedFacility);
                    }
                });
            }
        });
    }

    componentWillUnmount() {
        this.alive = false;
    }

    handleDateChange = (dates, selectedDateRange) => {
        this.setState({
            selectedDateRange,
            dates
        });
    }

    handleFacilityChange = (selectedFacility) => {
        this.setState({
            selectedFacility,
            availableTechs: this.state.allFacilities.find(f => f.facilityModel.facilityID === selectedFacility)?.availableTechs || [],
            selectedTech: '',
            availableExamTypes: this.state.allFacilities.find(f => f.facilityModel.facilityID === selectedFacility)?.availableExamTypes || [],
        });
    }

    handleTechChange = (selectedTech) => {
        this.setState({
            selectedTech
        });
    }

    handleExamTypesChange = (selectedExamTypes) => {
        this.setState({
            selectedExamTypes
        });
    }

    handleClear = () => {
        this.setState({
            selectedFacility: '',
            selectedTech: '',
            availableTechs: [],
            selectedExamTypes: [],
            selectedDates: {
                startDate: null,
                endDate: null
            },
            showDetails: false
        })
    }

    handleNewDateChange = (name, date) => {
        this.setState({ selectedDates: { ...this.state.selectedDates, [name]: date } });
    }

    handleInputChange = () => {
        this.setState({
            showDetails: !this.state.showDetails
        });
    }

    handleSubmit = () => {

        let endDate = this.state.selectedDates.endDate ? Moment(this.state.selectedDates.endDate).format("YYYY-MM-DD") : null;
        let startDate = this.state.selectedDates.startDate ? Moment(this.state.selectedDates.startDate).format("YYYY-MM-DD") : null;
        
        if (this.state.selectedFacility) {
            const q = Axios.defaults.baseURL + "api/RenderTechDetailsAndSummary";


            var form = document.createElement("form");
            form.target = "_blank";
            form.method = "POST";
            form.action = q;
            form.style.display = "none";

            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "startDate";
            input.value = startDate;
            form.appendChild(input);

            var input1 = document.createElement("input");
            input1.type = "hidden";
            input1.name = "endDate";
            input1.value = endDate;
            form.appendChild(input1);

            var input2 = document.createElement("input");
            input2.type = "hidden";
            input2.name = "selectedFacility";
            input2.value = this.state.selectedFacility;
            form.appendChild(input2);

            var input3 = document.createElement("input");
            input3.type = "hidden";
            input3.name = "selectedTech";
            input3.value = this.state.selectedTech;
            form.appendChild(input3);

            var input4 = document.createElement("input");
            input4.type = "hidden";
            input4.name = "selectedExamTypes";
            input4.value = this.state.selectedExamTypes;
            form.appendChild(input4);

            var input5 = document.createElement("input");
            input5.type = "hidden";
            input5.name = "showDetails";
            input5.value = this.state.showDetails;
            form.appendChild(input5);

            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "ianaTimezone";
            input.value = Intl.DateTimeFormat().resolvedOptions().timeZone;
            form.appendChild(input);

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        } else {
            toast.error("Please select a facility.");
        }
        
    }

    exportExcel = () => {
        const key = "loading";
        message.loading({ content: 'Exporting Tech Summary...', key, duration: 0 });
        let fileName = "tech-summary_" + Moment().format('YYYYMMDDHm') + '.xlsx';

        let postdata = {
            fileName,
            sDate: this.state.selectedDates.startDate ? Moment(this.state.selectedDates.startDate).format("YYYY-MM-DD") : null,
            eDate: this.state.selectedDates.endDate ? Moment(this.state.selectedDates.endDate).format("YYYY-MM-DD") : null,
            selectedFacility: this.state.selectedFacility,
            selectedTech: this.state.selectedTech,
            selectedExamTypes: this.state.selectedExamTypes,
            showDetails: this.state.showDetails,
            ianaTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }

        downloadTechSummary(postdata).then(data => {
            const url = window.URL.createObjectURL(new Blob([data]));
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = fileName;//"File.xlsx";
            //document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);

            message.destroy(key);

            this.setState({
                downloading: false
            })
        }).catch(error => {
            console.log("Error");
        });
    }
    

    render() {

        const { Option } = Select;

        const theme = window.sessionStorage.getItem("theme");

        return (
            <Modal size='lg' show={this.state.showModal} onHide={this.toggleModal} backdrop='static' dialogClassName={theme === 'dark' ? "dark-theme" : 'light-theme'}>
                <Modal.Header>
                    <h1>Tech Summary Report</h1>
                </Modal.Header>
                <Modal.Body className="no-y-overflow">
                    <div className="panel-content">
                        {this.state.loaded &&
                            <div className="row">

                            <div className="form-group col col-6">
                                <div className="form-label">Start Range <span className="color-pink">*</span></div>
                                <DatePicker
                                    onChange={(date) => this.handleNewDateChange('startDate', date)}
                                    selectsStart
                                    startDate={this.state.selectedDates.startDate}
                                    endDate={this.state.selectedDates.endDate}
                                    className="form-control-custom"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    placeholderText='Start Date'
                                    selected={this.state.selectedDates.startDate && Moment(this.state.selectedDates.startDate).toDate()}
                                    customInput={
                                        <NumberFormat format="##/##/####" mask="_" />
                                    }
                                />
                            </div>
                            <div className="col col-6">
                                <div className="form-label">End Range <span className="color-pink">*</span></div>
                                <DatePicker
                                    onChange={(date) => this.handleNewDateChange('endDate', date)}
                                    selectsEnd
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    startDate={this.state.selectedDates.startDate}
                                    endDate={this.state.selectedDates.endDate}
                                    className="form-control-custom"
                                    placeholderText='End Date'
                                    selected={this.state.selectedDates.endDate && Moment(this.state.selectedDates.endDate).toDate()}
                                    customInput={
                                        <NumberFormat format="##/##/####" mask="_" />
                                    }
                                />

                            </div>

                            <div className="form-group col col-lg-6 col-12">
                                <div className="form-label">Facility <span className="color-pink">*</span></div>
                                {this.state.allFacilities.length === 1 ?
                                    <div>{this.state.allFacilities[0].facilityModel.facilityName}</div>
                                    :
                                    <Select
                                        allowClear
                                        placeholder="Please select"
                                        onChange={this.handleFacilityChange}
                                        className="form-control-custom w-100"
                                        bordered={false}
                                        value={this.state.selectedFacility}
                                        showSearch
                                        virtual={false}
                                        filterOption={(input, option) => (option.children[0] + option.children[1]).toLowerCase().includes(input.toLowerCase())}
                                    >
                                        {this.state.allFacilities.map((fac, idx) => <Option key={idx} key={fac.facilityModel.facilityID} value={fac.facilityModel.facilityID}>{fac.facilityModel.facilityNumber && fac.facilityModel.facilityNumber + " - "}{fac.facilityModel.facilityName}</Option>)}
                                    </Select>
                                }

                            </div>

                            {/*    <div className="form-group col col-lg-6 col-12">*/}
                            {/*    <div className="form-label">Facility <span className="color-pink">*</span></div>*/}
                            {/*    <Select*/}
                            {/*            allowClear*/}
                            {/*            placeholder="Please select"*/}
                            {/*            onChange={this.handleFacilityChange}*/}
                            {/*            className="form-control-custom w-100"*/}
                            {/*        bordered={false}*/}
                            {/*        value={this.state.selectedFacility}*/}
                            {/*        showSearch*/}
                            {/*        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}*/}
                            {/*        >*/}
                            {/*        {this.state.allFacilities.map((fac, idx) => <Option key={idx} key={fac.facilityModel.facilityID} value={fac.facilityModel.facilityID}>{fac.facilityModel.facilityNumber && fac.facilityModel.facilityNumber + " - "}{fac.facilityModel.facilityName}</Option>)}*/}
                            {/*        </Select>*/}
                            {/*</div>*/}
                            <div className="form-group col col-lg-6 col-12">
                                <div className="form-label">Technologist</div>
                                <Select
                                    allowClear
                                    placeholder="Please select"
                                    onChange={this.handleTechChange}
                                    className="form-control-custom w-100"
                                    bordered={false}
                                    virtual={false}
                                    value={this.state.selectedTech}
                                >
                                    {this.state.availableTechs.map((t, idx) => <Option key={idx} key={t.userID} value={t.userID}>{t.fName} {t.lName}</Option>)}
                                </Select>
                            </div>

                            <div className="form-group col col-lg-6 col-12">
                                <div className="form-label">Exam Types</div>
                                <Select
                                    mode="multiple"
                                    maxTagCount={1}
                                    allowClear
                                    placeholder="Please select"
                                    onChange={this.handleExamTypesChange}
                                    className="form-control-custom w-100"
                                    bordered={false}
                                    virtual={false}
                                    value={this.state.selectedExamTypes}
                                >
                                    {this.state.availableExamTypes.map((e, idx) => <Option key={idx} key={e.examTypeID} value={e.examTypeID}>{e.examType}</Option>)}
                                </Select>
                            </div>

                            <div className="form-group col-lg-6">
                                <label className="form-label">Show Detailed Report</label>
                                <div className="form-control-custom no-border">
                                    <div className="custom-control custom-checkbox custom-control-inline">
                                        <input type="checkbox" className="custom-control-input" id="showDetails" name="showDetails" value={this.state.showDetails || ''} onChange={this.handleInputChange} />
                                        <label className="custom-control-label"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                            


                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-submit float-left" onClick={this.handleSubmit} style={{ left: '10px', position: 'fixed', backgroundColor: '#1D6F42', borderColor: '#1D6F42' }}>Export to PDF</button>
                    <div className="row">
                        <div className="form-group col-12 padding-25-10">
                            <button className="btn btn-submit" onClick={this.exportExcel}>Run Report</button>
                            <button className="btn btn-outline-default margin-left-15" onClick={this.handleClear}>Clear</button>
                            <button className="btn btn-outline-default margin-left-15" id="closeModal" onClick={() => this.props.hideModal()}>Cancel</button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withRouter(TechDetailsReportModal);